<template>
  <a-card
    :bordered="false"
    ref="card-chart"
  >
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <div
        @click="handleExpand"
        class="search-expand"
      >
        {{ this.isExpand ? '收起' : '展开' }}
        <a-icon :type="this.isExpand ? 'up' : 'down'" />
      </div>
      <a-form layout="inline">
        <a-row :gutter="12">
          <a-col :span="5">
            <a-form-item label="项目名称">
              <a-select
                showSearch
                :allowClear="true"
                @change="onChangePro"
                placeholder="请输入项目"
                v-model="queryParam.projectId"
              >
                <a-select-option
                  :key="d.id"
                  v-for="d in proDatas"
                >{{ d.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="5">
            <a-form-item label="虚拟组">
              <a-select
                :allowClear="true"
                @change="onChangeMod"
                @filterOption="onSearchMod"
                optionFilterProp="children"
                placeholder="请输入虚拟组"
                showSearch
                v-model="queryParam.groupId"
              >
                <a-select-option
                  :key="d.id"
                  :value="d.id"
                  v-for="d in mkDatas"
                >{{ d.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="7">
            <a-form-item label="设备">
              <a-select
                :max-tag-text-length="10"
                mode="multiple"
                v-model="checkedListSb"
              >
                <a-select-option
                  :key="d.id"
                  :label="d.sidNo"
                  :value="d.sidNo"
                  v-for="d in sbDatas"
                >{{ d.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="4">
            <a-form-item label="曲线类型">
              <a-select
                defaultValue="value17_18"
                mode="multiple"
                placeholder="请输值类型"
                v-model="queryParam.zlxs"
              >
                <a-select-option value="value15_16">温度</a-select-option>
                <a-select-option value="value17_18">测量值</a-select-option>
                <a-select-option value="value19_20">变化值</a-select-option>
                <a-select-option value="value21_22">应变频率</a-select-option>
                <a-select-option value="value23_24">补偿频率</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="3">
            <span
              class="table-page-search-submitButtons"
              style="float: right;overflow: hidden;"
            >
              <a-button
                @click="searchQuery"
                icon="search"
                type="primary"
              >查询</a-button>
              <a-button
                @click="searchReset"
                icon="reload"
                style="margin-left: 8px"
                type="primary"
              >重置</a-button>
            </span>
          </a-col>
        </a-row>
        <div
          style="margin-top: 12px;"
          v-show="isExpand"
        >
          <a-row :gutter="12">
            <a-col :span="5">
              <a-form-item label="数据时间">
                <a-date-picker
                  format="YYYY-MM-DD HH:mm:ss"
                  showTime
                  style="min-width: 100% !important;width: 100%"
                  v-model="queryParam.dtBegin"
                />
              </a-form-item>
            </a-col>
            <a-col :span="5">
              <a-form-item label="截止到">
                <a-date-picker
                  format="YYYY-MM-DD HH:mm:ss"
                  showTime
                  style="min-width: 100% !important;width: 100%"
                  v-model="queryParam.dtEnd"
                />
              </a-form-item>
            </a-col>
            <a-col :span="4">
              <a-form-item label="时间起点">
                <a-select
                  :allowClear="true"
                  defaultValue="1"
                  v-model="queryParam.sjjg"
                >
                  <a-select-option
                    :key="d.id"
                    v-for="d in sjdDatas"
                  >{{ d.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="3">
              <a-form-item label="截止点">
                <a-select
                  :allowClear="true"
                  defaultValue="1"
                  v-model="queryParam.sjjgEnd"
                >
                  <a-select-option
                    :key="d.id"
                    v-for="d in sjdDatas"
                  >{{ d.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="4">
              <a-form-item label="数据源">
                <a-select
                  defaultValue="1"
                  v-model="queryParam.ds"
                >
                  <a-select-option value="0">低频数据</a-select-option>
                  <a-select-option value="4">高频数据</a-select-option>
                  <a-select-option value="1">补值数据</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
        </div>
      </a-form>
    </div>
   
    <!-- 曲线图-测量值 -->
    <div class="chart_pic">
      <div
        class="left-title"
        v-show="clFlag"
      >
        测
        <br />量
        <br />值
      </div>
      <div
        class="data-chart"
        id="clPic"
      ></div>
      <div
        class="right-info"
        v-show="clFlag"
      >
        <!-- <h4 class="right-info__title">测量值</h4> -->
        <div>
          
          <table class="right-info__table">
            <tr>
              <td>仪器</td>
              <td>max</td>
              <td>min</td>
              <td>单位</td>
            </tr>
            <tr
              :key="d.sbName"
              class="table-row"
              v-for="d in sbMaxList"
            >
              <td>{{ d.name }}</td>
              <td>{{ d.max_clz }}</td>
              <td>{{ d.min_clz }}</td>
              <td>{{ d.dw }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <!-- 曲线图-变化值 -->
    <div class="chart_pic">
      <div
        class="left-title"
        v-show="pcFlag"
      >
        偏
        <br />差
        <br />值
      </div>
      <div
        class="data-chart"
        id="pcPic"
      ></div>
      <div
        class="right-info"
        v-show="pcFlag"
      >
        <!-- <h4 class="right-info__title">变化值</h4> -->
        <div>
          <table class="right-info__table">
            <tr>
              <td>仪器</td>
              <td>max</td>
              <td>min</td>
              <td>单位</td>
            </tr>
            <tr
              :key="d.sbName"
              class="table-row"
              v-for="d in sbMaxList"
            >
              <td>{{ d.name }}</td>
              <td>{{ d.max_pcz }}</td>
              <td>{{ d.min_pcz }}</td>
              <td>{{ d.dw }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <!-- 曲线图-应变频率 -->
    <div class="chart_pic">
      <div
        class="left-title"
        v-show="ybFlag"
      >
        应
        <br />变
        <br />频
        <br />率
      </div>
      <div
        class="data-chart"
        id="ybPic"
      ></div>
      <div
        class="right-info"
        v-show="ybFlag"
      >
        <!-- <h4 class="right-info__title">应变频率</h4> -->
        <div>
          <table class="right-info__table">
            <tr>
              <td>仪器</td>
              <td>max</td>
              <td>min</td>
              <td>单位</td>
            </tr>
            <tr
              :key="d.sbName"
              class="table-row"
              v-for="d in sbMaxList"
            >
              <td>{{ d.name }}</td>
              <td>{{ d.max_yb }}</td>
              <td>{{ d.min_yb }}</td>
              <td>{{ d.dw }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <!-- 曲线图-补偿频率 -->
    <div class="chart_pic">
      <div
        class="left-title"
        v-show="bcFlag"
      >
        补
        <br />偿
        <br />频
        <br />率
      </div>
      <div
        class="data-chart"
        id="bcPic"
      ></div>
      <div
        class="right-info"
        v-show="bcFlag"
      >
        <!-- <h4 class="right-info__title">补偿频率</h4> -->
        <div>
          <table class="right-info__table">
            <tr>
              <td>仪器</td>
              <td>max</td>
              <td>min</td>
              <td>单位</td>
            </tr>
            <tr
              :key="d.sbName"
              class="table-row"
              v-for="d in sbMaxList"
            >
              <td>{{ d.name }}</td>
              <td>{{ d.max_bc }}</td>
              <td>{{ d.min_bc }}</td>
              <td>{{ d.dw }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
     <!-- 曲线图-温度 -->
    <div class="chart_pic">
      <div
        class="left-title"
        v-show="wdFlag"
      >
        温
        <br />度
      </div>
      <div
        class="data-chart"
        id="wdPic"
      ></div>
      <div
        class="right-info"
        v-show="wdFlag"
      >
        <!-- <h4 class="right-info__title">温度</h4> -->
        <div>
          <table class="right-info__table">
            <tr>
              <td>仪器</td>
              <td>max</td>
              <td>min</td>
              <td>单位</td>
            </tr>
            <tr
              :key="d.sbName"
              class="table-row"
              v-for="d in sbMaxList"
            >
              <td>{{ d.name }}</td>
              <td>{{ d.max_wd }}</td>
              <td>{{ d.min_wd }}</td>
              <td>℃</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </a-card>
</template>

<script>
// import { filterObj } from '@/utils/util'
import { getAction } from '@/api/manage'
import moment from "moment"

export default {
  name: "MyEchart",
  components: {
  },
  data () {
    return {
      isExpand: true,
      label: {
        textStyle: {
          fill: '#aaaaaa'
        }
      },
      userId:null,
      scale: [{
        dataKey: 'dt',
        //range: [0, 1],
        tickCount: 10,
        type: 'time',
        mask: 'YYYY-MM-DD HH:mm:ss',
      }],
      //数据集
      data: [],
      //padding2:[20, 110, 70, 35],
      sjdDatas: [{ id: 0, name: '0:00' }, { id: 1, name: '1:00' }, { id: 2, name: '2:00' }, { id: 3, name: '3:00' },
      { id: 4, name: '4:00' }, { id: 5, name: '5:00' }, { id: 6, name: '6:00' }, { id: 7, name: '7:00' },
      { id: 8, name: '8:00' }, { id: 9, name: '9:00' }, { id: 10, name: '10:00' }, { id: 11, name: '11:00' },
      { id: 12, name: '12:00' }, { id: 13, name: '13:00' }, { id: 14, name: '14:00' }, { id: 15, name: '15:00' },
      { id: 16, name: '16:00' }, { id: 17, name: '17:00' }, { id: 18, name: '18:00' }, { id: 19, name: '19:00' },
      { id: 20, name: '20:00' }, { id: 21, name: '21:00' }, { id: 22, name: '22:00' }, { id: 23, name: '23:00' }],

      description: '数据曲线查看',
      // 查询条件
      queryParam: { zlxs: ['value17_18'], ds: '1', dtBegin: moment(new Date()).add(-7, 'days') },
      mkDatas: [],
      proDatas: [],
      sbDatas: [],
      checkedListSb: [],

      style: { stroke: '#fff', lineWidth: 1 },

      clFlag: false, dataCl: [], clPic: null,
      wdFlag: false, dataWd: [], wdPic: null,
      pcFlag: false, dataPc: [], pcPic: null,
      ybFlag: false, dataYb: [], ybPic: null,
      bcFlag: false, dataBc: [], bcPic: null,
      allDt: [],
      allSid: [],
      // 设备最大值最小值map
      sbValueMap: new Map(),
      sbMaxList: [],

      loading: false,
      url: {
        list: "/show/dataMeasureNormal/list",
        listChart: "/show/dataMeasureNormal/listChart",
        getProList: "/project/project/listAllTest",

        getVmgroupListByxm: "/project/vmgroup/listByProjectIdtest",
        getVmgroupIds:"/device/device/listByVmgroupIdstest",
      },

    }
  },
  created () {
    //获取用户标识参数
    this.userId = this.$route.query.id;
    console.log(this.userId);
    this.getProDatas();
  },
  mounted() {
    // 监听页面resize 进行重新查询
    this.$nextTick(() => {
      window.addEventListener('resize',this.resizeFn)
      this.$once('hook:beforDestroy', () => {
        window.removeEventListener('resize', this.resizeFn)
      })
    })
    
  },
  methods: {
    resizeFn() {
      setTimeout(() => {
        this.searchQuery()
      }, 200)
    },
    loadPic (type) {
      let clPic = null;
      let mySeries = [];
      if (type == "value15_16") {
        clPic = this.wdPic;
        mySeries = this.dataWd;
        //document.getElementById('wdPic').style.height="400px";
      } else if (type == "value17_18") {
        clPic = this.clPic;
        mySeries = this.dataCl;
        //document.getElementById('clPic').style.display="block";
      } else if (type == "value19_20") {
        clPic = this.pcPic;
        mySeries = this.dataPc;
        //document.getElementById('pcPic').style.height="400px";
      } else if (type == "value21_22") {
        clPic = this.ybPic;
        mySeries = this.dataYb;
        //document.getElementById('ybPic').style.height="400px";
      } else if (type == "value23_24") {
        clPic = this.bcPic;
        mySeries = this.dataBc;
        //document.getElementById('bcPic').style.height="400px";
      }

      let mySids = this.allSid;
      let myDts = this.allDt;
      //console.log(mySids);
      //console.log(myDts);
      //console.log(mySeries);

      //clPic.clear();
      clPic.getDom().style.height = "300px";
      clPic.resize();

      // 指定图表的配置项和数据
      var option = {
        color: ['#6ED7B3', '#1751C3', '#CCA85B'],
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: mySids,
          left: 'center',
          top: 'bottom',
          textStyle: {
            color: '#60648e'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '7%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: myDts,
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: '#60648e'
          }
        },
        yAxis: {
          type: 'value',
          scale: true,
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          splitLine: {
            lineStyle: {
              color: '#5D649E'
            }
          },
          axisLabel: {
            color: '#60648e'
          }
        },
        series: mySeries,
      };
      // 使用刚指定的配置项和数据显示图表。
      clPic.setOption(option, true);
    },
    loadData () {
      let _this = this;

      _this.wdFlag = false;
      _this.clFlag = false;
      _this.pcFlag = false;
      _this.ybFlag = false;
      _this.bcFlag = false;

      if (this.clPic == null) {
        this.clPic = this.$echarts.init(document.getElementById('clPic'));
        this.wdPic = this.$echarts.init(document.getElementById('wdPic'));
        this.pcPic = this.$echarts.init(document.getElementById('pcPic'));
        this.ybPic = this.$echarts.init(document.getElementById('ybPic'));
        this.bcPic = this.$echarts.init(document.getElementById('bcPic'));
      }

      this.clPic.getDom().style.height = "0px";
      this.clPic.resize();
      this.wdPic.getDom().style.height = "0px";
      this.wdPic.resize();
      this.pcPic.getDom().style.height = "0px";
      this.pcPic.resize();
      this.ybPic.getDom().style.height = "0px";
      this.ybPic.resize();
      this.bcPic.getDom().style.height = "0px";
      this.bcPic.resize();

      if (!this.queryParam.groupId) {
        _this.$message.warning('请选择虚拟组再进行查询！');
        return;
      }
      //console.log(this.checkedListSb);
      if (this.checkedListSb.length <= 0) {
        if(this.sbDatas.length <= 0){
          _this.$message.warning('虚拟组没有设备可以进行查询！');
          return;
        }
        this.checkedListSb = this.sbDatas.map(v => { return v.sidNo });
      }
      if (this.queryParam.zlxs.length == 0) {
        _this.$message.warning('请选择值类型再进行查询！');
        return;
      }

      let typecha = (this.queryParam.ds == 0 ? 3 : 24);
      let end = this.queryParam.dtEnd;
      if (!this.queryParam.dtEnd) {
        end = moment();
      }
      if (!this.queryParam.dtBegin) {
        _this.$message.warning('数据时间为空，默认查询' + typecha + '个月数据！');
        this.queryParam.dtBegin = moment(end.valueOf()).add(-typecha, 'months');
      }
      if (end.diff(this.queryParam.dtBegin, 'months') > typecha) {
        let typestr = (this.queryParam.ds == 0 ? '查询原始' : '查询补值');
        _this.$message.warning(typestr + '数据时间超过' + typecha + '个月，不能查询！');
        return;
      }

      var params = this.getQueryParams();//查询条件
      if (params.dtBegin) {
        params.dtBegin = params.dtBegin.format("YYYY-MM-DD HH:mm:ss");
      }
      if (params.dtEnd) {
        params.dtEnd = params.dtEnd.format("YYYY-MM-DD HH:mm:ss");
      }

      params.sidNos = this.checkedListSb.join(",");
      let zlxs = this.queryParam.zlxs;
      //console.log('=====');
      //console.log(zlxs);
      params.zlxs = zlxs.join(",");

      //console.log(params);
      getAction(this.url.listChart, params).then((res) => {
        if (res.success) {
          if (!res.result) {
            _this.$message.warning('没有查询到数据！');
            return;
          }
          // 计算最大值最小值，并转换为echarts数据格式
          _this.setMaxAndConvert(res.result.allData);
          _this.data = res.result.allData;

          //console.log(res.result);
          zlxs.forEach(function (value) {
            //console.log(index+":"+value.id);
            if ("value15_16" == value) {
              _this.wdFlag = true;
              _this.loadPic("value15_16");
            } else if ("value17_18" == value) {
              _this.clFlag = true;
              _this.loadPic("value17_18");
            } else if ("value19_20" == value) {
              _this.pcFlag = true;
              _this.loadPic("value19_20");
            } else if ("value21_22" == value) {
              _this.ybFlag = true;
              _this.loadPic("value21_22");
            } else if ("value23_24" == value) {
              _this.bcFlag = true;
              _this.loadPic("value23_24");
            }
          });
        } else {
          _this.$message.warning('没有查询到数据！');
        }
      })
    },

    getQueryParams () {
      var param = Object.assign({}, this.queryParam);
      if (param.dt) {
        param.dt = param.dt.format("YYYY-MM-DD HH:mm");
      }
      return param;
    },
    searchQuery () {
      this.loadData();
    },
    searchReset () {
      var that = this;
      that.queryParam = { zlxs: ['value17_18'], ds: '1' };

      that.mkDatas = [];
      that.sbDatas = [];
    },
    getMkDatas (proId) {
      getAction(this.url.getVmgroupListByxm, { pid: proId,uid: this.userId }).then((res) => {
        if (res.success) {
          this.mkDatas = res.result;
          this.checkedListMk = [];// 清空
        }
      });
    },
    getProDatas () {
      getAction(this.url.getProList, {uid:this.userId}).then((res) => {
        if (res.success) {
          this.proDatas = res.result;
        }
      })
    },
    onChangePro (val) {
      this.mkDatas = [];
      if (val) {
        getAction(this.url.getVmgroupListByxm, { pid: val,uid:this.userId }).then((res) => {
          if (res.success) {
            this.mkDatas = res.result;
          }
        });
        this.queryParam.groupId = null;
        // 清空设备选中项
        this.checkedListSb = [];
      }
    },
    onChangeMod (val) {
      this.sbDatas = [];
      // 清空设备选中项
      this.checkedListSb = [];

      if (val) {
        getAction(this.url.getVmgroupIds, { gIds: val,uid:this.userId }).then((res) => {
          if (res.success) {
            this.sbDatas = res.result;
          }
        });
      }
    },
    onSearchMod (input, option) {
      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    onSearchSid (input, option) {
      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    // 计算最大值最小值，并转换为echarts数据格式
    setMaxAndConvert (dataAll) {
      let that = this;
      that.allSid = [];
      that.sbValueMap.clear();
      //that.sbMaxList = [];
      that.allDt = [];
      let dtMap = new Map();

      let sidMapWd = new Map();
      let sidMapCl = new Map();
      let sidMapPc = new Map();
      let sidMapYb = new Map();
      let sidMapBc = new Map();
      that.dataWd = [];
      that.dataCl = [];
      that.dataPc = [];
      that.dataYb = [];
      that.dataBc = [];

      // 遍历一遍，设置最大最小值
      dataAll.forEach(function (v) {
        // 转换为echarts数据
        let curWd = [v.dt, v.value15_16];
        let curCl = [v.dt, v.value17_18];
        let curPc = [v.dt, v.value19_20];
        let curYb = [v.dt, v.value21_22];
        let curBc = [v.dt, v.value23_24];
        if (sidMapWd.has(v.sbName)) {
          sidMapWd.get(v.sbName).push(curWd);
          sidMapCl.get(v.sbName).push(curCl);
          sidMapPc.get(v.sbName).push(curPc);
          sidMapYb.get(v.sbName).push(curYb);
          sidMapBc.get(v.sbName).push(curBc);

          //最大值最小值计算
          let vObj = that.sbValueMap.get(v.sbName);
          //温度
          if (vObj.max_wd < v.value15_16) {
            vObj.max_wd = v.value15_16;
          }
          if (vObj.min_wd > v.value15_16) {
            vObj.min_wd = v.value15_16;
          }
          //测量值
          if (vObj.max_clz < v.value17_18) {
            vObj.max_clz = v.value17_18;
          }
          if (vObj.min_clz > v.value17_18) {
            vObj.min_clz = v.value17_18;
          }
          //变化值
          if (vObj.max_pcz < v.value19_20) {
            vObj.max_pcz = v.value19_20;
          }
          if (vObj.min_pcz > v.value19_20) {
            vObj.min_pcz = v.value19_20;
          }
          //应变频率
          if (vObj.max_yb < v.value21_22) {
            vObj.max_yb = v.value21_22;
          }
          if (vObj.min_yb > v.value21_22) {
            vObj.min_yb = v.value21_22;
          }
          //补偿频率
          if (vObj.max_bc < v.value23_24) {
            vObj.max_bc = v.value23_24;
          }
          if (vObj.min_bc > v.value23_24) {
            vObj.min_bc = v.value23_24;
          }

        } else {
          that.allSid.push(v.sbName);
          let vObj = {name: v.sbName, dw:v.unit,
            max_wd:v.value15_16, max_clz:v.value17_18, max_pcz:v.value19_20, max_yb:v.value21_22, max_bc:v.value23_24,
            min_wd:v.value15_16, min_clz:v.value17_18, min_pcz:v.value19_20, min_yb:v.value21_22, min_bc:v.value23_24,
          };
          that.sbValueMap.set(v.sbName, vObj);

          let tempWd = [];
          tempWd.push(curWd);
          sidMapWd.set(v.sbName, tempWd);
          that.dataWd.push({ name: v.sbName, type: 'line', connectNulls: true, smooth: true, data: tempWd });

          let tempCl = [];
          tempCl.push(curCl);
          sidMapCl.set(v.sbName, tempCl);
          that.dataCl.push({ name: v.sbName, type: 'line', connectNulls: true, smooth: true, data: tempCl });

          let tempPc = [];
          tempPc.push(curPc);
          sidMapPc.set(v.sbName, tempPc);
          that.dataPc.push({ name: v.sbName, type: 'line', connectNulls: true, smooth: true, data: tempPc });

          let tempYb = [];
          tempYb.push(curYb);
          sidMapYb.set(v.sbName, tempYb);
          that.dataYb.push({ name: v.sbName, type: 'line', connectNulls: true, smooth: true, data: tempYb });

          let tempBc = [];
          tempBc.push(curBc);
          sidMapBc.set(v.sbName, tempBc);
          that.dataBc.push({ name: v.sbName, type: 'line', connectNulls: true, smooth: true, data: tempBc });
        }

        // 转换为echarts数据，时间处理
        if (!dtMap.has(v.dt)) {
          dtMap.set(v.dt, 0);
          that.allDt.push(v.dt);
        }

      });

      //最大值、最小值，并按名称排序
      that.sbMaxList = [];
      that.sbValueMap.forEach(function (value, key, map) {
        that.sbMaxList.push(value);
      });
      //排序
      that.sbMaxList.sort(function(a,b){
        return a.name.localeCompare(b.name);
      });

    },
    handleExpand () {
      this.isExpand = !this.isExpand
    }

  }
}
</script>
<style lang="less" scoped>
::v-deep .ant-card-body {
  padding: 0;
  background-color: #353C84;
  height: 1770px;
}
.mini-area {
  margin-bottom: 18px;
}
.ant-layout-content {
  margin: 12px 16px 0 !important;
}
.ant-table-tbody .ant-table-row td {
  padding-top: 15px;
  padding-bottom: 15px;
}
.anty-row-operator button {
  margin: 0 5px;
}
.ant-btn-danger {
  background-color: #ffffff;
}

.ant-modal-cust-warp {
  height: 100%;
}
.ant-modal-cust-warp .ant-modal-body {
  height: calc(100% - 110px) !important;
  overflow-y: auto;
}
.ant-modal-cust-warp .ant-modal-content {
  height: 90% !important;
  overflow-y: hidden;
}
.chart_bg {
  background-color: #42516b;
}
.chart_title {
  font-size: 20px;
  font-weight: bold;
  color: #ffffff;
  position: absolute;
  top: 12px;
  margin-left: 3%;
}
.list-select {
  width: 240px;
  height: 200px;
  float: left;
  border: 1px solid #d8d8d8;
  overflow-y: scroll;
}
.list-select-s {
  width: 320px;
  height: 200px;
  float: left;
  border: 1px solid #d8d8d8;
  overflow-y: scroll;
}
.max_font {
  font-size: 16px;
  color: #3e66ce;
  font-weight: normal;
}
.chart_pic {
  display: flex;
  // position: relative;
  margin-top: 16px;
  .data-chart {
    width: calc(100% - 230px);
  }
  .left-title {
    padding: 8px;
    display: flex;
    align-items: center;
    color: #ccc;
    font-weight: 700;
  }
  .right-info {
    width: 200px;
    color: #ccc;
    padding-top: 40px;
    /* .right-info__title {
      font-weight: bold;
      color: #ccc;
      margin-bottom: 16px;
    } */
    .right-info__table .table-row td {
      &:nth-child(2),
      &:nth-child(3) {
        color: #e94242;
      }
    }
    .right-info__table td {
      padding: 2px 4px;
      text-align: center;
    }
    .right-info__min {
      margin-left: 12px;
    }
  }
} /* height:400px;border:1px solid #D8D8D8; */
::v-deep.table-page-search-wrapper .ant-form-inline .ant-form-item > .ant-form-item-label {
  width: 70px;
}
</style>